import React, { useEffect } from "react";
import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import BroadcastOnPersonalIcon from "@mui/icons-material/BroadcastOnPersonal";
import { getData } from "../../../services/library";
import Navbar from "../../Navbar";
import { enviarsms } from "../../../services/services";

const UsersSinPedir = () => {
  const [loading, setLoading] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    getData("/viandas/pedidosFaltantes", setUsers);
  }, []);

  const handleSendSMS = async (usuario, isGlobal = false) => {
    try {
      const usuariosParaEnviar = isGlobal
        ? users.filter((u) => u.celular !== "-")
        : [usuario];

      usuariosParaEnviar.forEach((user) => {
        setTimeout(() => {
          const message = `${user.nombrepila} ${user.apellido} quedan 15 minutos para seleccionar las viandas!`;
          enviarsms(user.celular, message);
        }, 300);
      });
      let message = `Se envio un SMS a ${
        usuario.nombrepila + " " + usuario.apellido
      }`;
      if (usuariosParaEnviar.length > 1)
        message = "Se enviaron los SMS a todos los usuarios";
      setSuccessMessage(message);
      setTimeout(() => {
        setSuccessMessage(null);
      }, 2200);
    } catch (error) {
      console.error("Error al enviar SMS:", error);
      setSuccessMessage("Error al enviar SMS:");
    } finally {
      setLoading(null);
    }
  };

  const usuariosSinSolicitud = users;
  const usuariosConCelular = usuariosSinSolicitud.filter(
    (u) => u.celular !== "-"
  );

  return (
    <>
      <Navbar />
      <Box sx={{ p: 4, minHeight: "100vh", bgcolor: "#f5f5f5" }}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
              Usuarios sin solicitar viandas
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {usuariosSinSolicitud.length} usuarios encontrados
            </Typography>
          </Box>

          {successMessage && (
            <Box
              sx={{
                p: 2,
                bgcolor: "#e8f5e9",
                color: "#2e7d32",
                borderRadius: 1,
                border: "1px solid #c8e6c9",
              }}
            >
              <Typography variant="body2">{successMessage}</Typography>
            </Box>
          )}

          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: "#f9f9f9" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Usuario</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Celular</TableCell>
                  <TableCell align="right" sx={{ fontWeight: "bold" }}>
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {usuariosSinSolicitud.map((usuario) => (
                  <TableRow key={usuario.username} hover>
                    <TableCell>
                      {usuario.nombrepila + " " + usuario.apellido}
                    </TableCell>
                    <TableCell>
                      {usuario.celular === "-" ? (
                        <Typography
                          sx={{ color: "text.secondary", fontStyle: "italic" }}
                        >
                          Sin celular
                        </Typography>
                      ) : (
                        usuario.celular
                      )}
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<SendIcon />}
                        onClick={() => handleSendSMS(usuario)}
                        disabled={usuario.celular === "-" || loading !== null}
                        sx={{
                          color:
                            usuario.celular === "-"
                              ? "text.disabled"
                              : "primary.main",
                        }}
                      >
                        {loading === usuario.username ? (
                          <CircularProgress size={20} />
                        ) : (
                          "Enviar SMS"
                        )}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<BroadcastOnPersonalIcon />}
              onClick={() => handleSendSMS({}, true)}
              disabled={usuariosConCelular.length === 0 || loading !== null}
              sx={{
                bgcolor: "#1976d2",
                "&:hover": { bgcolor: "#1565c0" },
              }}
            >
              {loading === "global" ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                `Enviar SMS a todos (${usuariosConCelular.length})`
              )}
            </Button>
            <Typography
              variant="body2"
              sx={{ alignSelf: "center", color: "text.secondary" }}
            >
              Se ignorarán usuarios sin celular registrado
            </Typography>
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default UsersSinPedir;
